import habitaciones from './habitaciones';
import pasajeros from './pasajeros';
import reservas from './reservas';
import usuarios from './usuarios';

const api = {
  habitaciones,
  reservas,
  pasajeros,
  usuarios,
};

export default api;
